import { render, staticRenderFns } from "./case-notes-table.vue?vue&type=template&id=e10aedda"
import script from "./case-notes-table.vue?vue&type=script&lang=js"
export * from "./case-notes-table.vue?vue&type=script&lang=js"
import style0 from "./case-notes-table.vue?vue&type=style&index=0&id=e10aedda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports